function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var RedSquareMenuTemplate = require('./menu.template');
var jsonTree = require('json-tree-viewer');
var SaitoOverlay = require('./../../../lib/saito/ui/saito-overlay/saito-overlay');
var Post = require('./post');
var RedSquareSettings = require('./settings');
var RedSquareMenu = /*#__PURE__*/function () {
  function RedSquareMenu(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, RedSquareMenu);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.container = container;
    this.settings = new RedSquareSettings(app, mod, '.module-settings-overlay');
    app.connection.on('redsquare-clear-menu-highlighting', function () {
      var active_tab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      document.querySelectorAll('.redsquare-page-active').forEach(function (el) {
        el.classList.remove('redsquare-page-active');
      });
      if (active_tab == 'tweets') {
        if (document.querySelector('.redsquare-menu-home')) {
          document.querySelector('.redsquare-menu-home').classList.add('redsquare-page-active');
        }
      }
      if (active_tab == 'notifications') {
        if (document.querySelector('.redsquare-menu-notifications')) {
          document.querySelector('.redsquare-menu-notifications').classList.add('redsquare-page-active');
        }
      }
      if (active_tab == 'profile') {
        if (document.querySelector('.redsquare-menu-profile')) {
          document.querySelector('.redsquare-menu-profile').classList.add('redsquare-page-active');
        }
      }
    });
    app.connection.on('redsquare-update-notifications', function (num) {
      _this.incrementNotifications(num);
    });
  }
  return _createClass(RedSquareMenu, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (document.querySelector('.redsquare-menu')) {
        this.app.browser.replaceElementBySelector(RedSquareMenuTemplate(this.app, this.mod), '.redsquare-menu');
      } else {
        this.app.browser.addElementToSelector(RedSquareMenuTemplate(this.app, this.mod), this.container);
      }

      //
      // adds chat toggle to left-menu
      //
      this.app.modules.returnModulesRespondingTo('saito-chat-popup').forEach(function (mod) {
        var id = "redsquare-menu-".concat(mod.returnSlug());
        var rs = mod.respondTo('saito-chat-popup')[0];
        _this2.app.browser.addElementToSelector("<li class=\"redsquare-menu-mobile item\" id=\"".concat(id, "\">\n            <i class=\"").concat(rs.icon, "\"></i>\n            <span>").concat(mod.returnName(), "</span>\n          </li>"), '.redsquare-menu');
        if (rs.event) {
          rs.event(id);
        }
        if (document.getElementById(id)) {
          document.getElementById(id).onclick = function () {
            if (rs.callback) {
              rs.callback(_this2.app, id);
            }
          };
        }
      });
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this3 = this;
      var this_self = this;
      try {
        document.querySelector('.tweet-button').onclick = function (e) {
          var post = new Post(_this3.app, _this3.mod);
          post.render();
        };
      } catch (err) {}

      //
      // new tweet (mobile)
      //
      //    if (document.getElementById('mobile-new-tweet') != null) {
      //      document.getElementById('mobile-new-tweet').onclick = (e) => {
      //        let post = new Post(this.app, this.mod);
      //        post.render();
      //      };
      //    }

      //
      // home
      //
      document.querySelector('.redsquare-menu-home').onclick = function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.info('RS.NAV: clicked home ...');
        if (window.location.hash || window.location.search) {
          _this3.app.connection.emit('redsquare-home-render-request');
        } else {
          _this3.app.connection.emit('redsquare-home-render-request', true);
          var ct = _this3.mod.loadTweets('later', function (tx_count) {
            _this3.app.connection.emit('redsquare-home-postcache-render-request', tx_count);
          });
          if (ct) {
            siteMessage("Checking with ".concat(ct, " peers for new tweets..."), 1000);
          }
        }
      };

      //
      // notifications
      //
      document.querySelector('.redsquare-menu-notifications').onclick = function (e) {
        _this3.app.connection.emit('redsquare-notifications-render-request');
      };

      //
      // profile
      //
      document.querySelector('.redsquare-menu-profile').onclick = function (e) {
        _this3.openProfile(_this3.mod.publicKey);
      };

      //
      // settings
      //
      if (document.querySelector('.redsquare-menu-settings')) {
        document.querySelector('.redsquare-menu-settings').onclick = function (e) {
          var overlay = new SaitoOverlay(_this3.app, _this3.mod);
          overlay.show("<div class=\"module-settings-overlay\"><h2>Redsquare Settings</h2></div>");
          _this3.settings.render();
        };
      }
      if (document.querySelector('.redsquare-menu-help')) {
        document.querySelector('.redsquare-menu-help').onclick = function (e) {
          _this3.overlay.show("<div class=\"debug_overlay\"></div>");
          var el = document.querySelector('.debug_overlay');
          if (document.querySelector('.tweet-html-markers.show')) {
            Array.from(document.querySelectorAll('.tweet-html-markers.show')).forEach(function (el) {
              el.classList.remove('show');
            });
          } else {
            Array.from(document.querySelectorAll('.tweet-html-markers')).forEach(function (el) {
              el.classList.add('show');
            });
          }
          if (!_this3.mod.styles.includes('/saito/lib/jsonTree/jsonTree.css')) {
            _this3.mod.styles.push('/saito/lib/jsonTree/jsonTree.css');
            _this3.mod.attachStyleSheets();
          }

          /*
          this.tweets = [];     // time sorted master list of tweets
          this.cached_tweets = []; // serialized-for-web version of curated_tweets
          this.tweets_sigs_hmap = {};
          this.unknown_children = [];
          this.orphan_edits = [];
          this.peers = [];
          this.keylist = {};
          this.tweet_count = 0;
          this.liked_tweets = [];
          this.retweeted_tweets = [];
          this.replied_tweets = [];
          this.hidden_tweets = [];
          */

          try {
            var optjson = JSON.parse(JSON.stringify(_this3.mod, function (key, value) {
              if (key == 'app') return 'app';
              if (key == 'mod') return 'mod';
              return typeof value === 'bigint' ? value.toString() : value; // return everything else unchanged
            }));
            var tree = jsonTree.create(optjson, el);
          } catch (err) {
            console.error('error creating jsonTree: ' + err);
            console.debug(_this3.mod);
          }
          console.log(_this3.mod.tweets_sigs_hmap);
        };
      }
    }
  }, {
    key: "openProfile",
    value: function openProfile(publicKey) {
      this.app.connection.emit('redsquare-profile-render-request', publicKey);
    }
  }, {
    key: "incrementNotifications",
    value: function incrementNotifications() {
      var notifications = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      var qs = ".redsquare-menu-notifications";
      if (document.querySelector(qs)) {
        qs = ".redsquare-menu-notifications > .saito-notification-dot";
        var obj = document.querySelector(qs);
        if (!obj) {
          if (notifications > 0) {
            this.app.browser.addElementToSelector("<div class=\"saito-notification-dot\">".concat(notifications, "</div>"), ".redsquare-menu-notifications");
          } else {
            this.app.browser.addElementToSelector("<div class=\"saito-notification-dot\"></div>", ".redsquare-menu-notifications");
            qs = ".redsquare-menu-notifications > .saito-notification-dot";
            var _obj = document.querySelector(qs);
            _obj.style.display = 'none';
          }
        } else {
          var existing_notifications = 0;
          if (obj.innerHTML) {
            existing_notifications = parseInt(obj.innerHTML);
          }
          if (notifications <= 0) {
            obj.style.display = 'none';
            obj.innerHTML = 0;
          } else {
            obj.style.display = 'flex';
            existing_notifications++;
            obj.innerHTML = existing_notifications;
          }
        }
      }
    }
  }]);
}();
module.exports = RedSquareMenu;